module.exports = __webpack_public_path__ + "static/img/api1.5d84075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/api1.png
// module id = AI2j
// module chunks = 1